import React from 'react';
import './styles/header.css';

// Rest of the component code

const Header = () => {
  return (
    <header>
      <h1>Gokalp Meric</h1>
      <nav>
        <ul>
          <li><a href="#home">Home</a></li>
          <li><a href="#about">About</a></li>
          <li><a href="#contact">Contact</a></li>
        </ul>
      </nav>
    </header>
  );
};

export default Header;
